import React from 'react';

interface AirportPair {
  departureAirportCode: string;
  arrivalAirportCode: string;
  lateDeparture: number;
  lateArrival: number;
  cancellation: number;
  diverted: number;
  total: number;
}

interface DisruptionsByRouteProps {
  data: {
    airportPairs: AirportPair[];
    lateDeparture: number;
    lateArrival: number;
    cancellation: number;
    diverted: number;
    grandTotal: number;
  };
}

const DisruptionsByRoute: React.FC<DisruptionsByRouteProps> = ({ data }) => {
  return (
    <div className="col-md-12">
      <div className="table-responsive">
        <table className="table table-striped table-hover report-table">
          <thead>
            <tr>
              <th className="header">Route</th>
              <th className="header">Late Departures</th>
              <th className="header">Late Arrivals</th>
              <th className="header">Cancellations</th>
              <th className="header">Diverted</th>
              <th className="header">Total</th>
            </tr>
          </thead>
          <tbody>
            {data.airportPairs.map((airportPair, index) => (
              <tr key={index}>
                <td>{airportPair.departureAirportCode} -&gt; {airportPair.arrivalAirportCode}</td>
                <td>{airportPair.lateDeparture}</td>
                <td>{airportPair.lateArrival}</td>
                <td>{airportPair.cancellation}</td>
                <td>{airportPair.diverted}</td>
                <td>{airportPair.total}</td>
              </tr>
            ))}
            <tr><td colSpan={6} className="grand-total"></td></tr>
            <tr>
              <td className="data-total">Grand Total</td>
              <td className="data-total">{data.lateDeparture}</td>
              <td className="data-total">{data.lateArrival}</td>
              <td className="data-total">{data.cancellation}</td>
              <td className="data-total">{data.diverted}</td>
              <td className="data-total">{data.grandTotal}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DisruptionsByRoute;